import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { minorConsentAgeGroups } from "@/mocks/legalPages";

/**
 * 未成年の方へ｜年齢別のご案内。
 * PC は3カード、スマホは縦並び。年齢区分を最も目立たせ、
 * 「親権者同意書」「親権者の同伴」の要否が一目で分かる構成にする。
 */
export default function AgeGuide() {
  return (
    <section className="bg-background-50 py-20 md:py-28 lg:py-32">
      <div className="u-container">
        <Reveal>
          <SectionHeading
            en="AGE GUIDE"
            jp="年齢別のご案内"
            lead="年齢によって必要なお手続きが異なります。"
          />
        </Reveal>

        <Reveal delay={120}>
          <ul className="mt-12 grid grid-cols-1 gap-6 md:mt-16 md:grid-cols-3 md:gap-8">
            {minorConsentAgeGroups.map((group) => (
              <li
                key={group.id}
                className={`flex flex-col rounded-lg border p-7 md:p-8 ${
                  group.emphasis
                    ? "border-accent-400 bg-background-100"
                    : "border-background-300/70 bg-background-50"
                }`}
              >
                <span className="en-eyebrow text-[10px] text-secondary-600">AGE</span>
                <h3 className="mt-5 font-heading text-[24px] leading-[1.4] text-foreground-950 md:text-[28px]">
                  {group.age}
                </h3>
                <span className="mt-6 block h-px w-10 bg-accent-500" />

                <dl className="mt-7 space-y-5">
                  <div>
                    <dt className="text-[12px] tracking-wide text-foreground-500">親権者同意書</dt>
                    <dd className="mt-1.5 font-heading text-[16px] text-foreground-950">
                      {group.consent}
                    </dd>
                  </div>
                  <div>
                    <dt className="text-[12px] tracking-wide text-foreground-500">親権者の同伴</dt>
                    <dd className="mt-1.5 font-heading text-[16px] text-foreground-950">
                      {group.accompany}
                    </dd>
                  </div>
                </dl>

                <p className="mt-7 border-t border-background-300/70 pt-6 text-[13px] leading-[2] text-foreground-700">
                  {group.description}
                </p>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}